import { makeAutoObservable } from "mobx";

class SidebarStore {

    show = false;

    constructor(){
        makeAutoObservable(this)
    }

    setShow(value){
        if (typeof value === "boolean") {
            this.show = value;
            return;
        }
        this.show = !this.show;
    }

}

const sidebarStore = new SidebarStore();

export default sidebarStore;